import { useEffect } from "react";
import { useI18n } from "@/lib/i18n";
import Index from "./Index";

const IndexEn = () => {
  const { setLang } = useI18n();

  useEffect(() => {
    setLang("en");
  }, [setLang]);

  return <Index />;
};

export default IndexEn;
